module.exports = __webpack_public_path__ + "img/l-cb6-001.932f3de1.gif";